// extracted by mini-css-extract-plugin
export var primary = "section-layout-module--primary--Wa3yN";
export var secondary = "section-layout-module--secondary--pr3c9";
export var wrapper = "section-layout-module--wrapper--2xLkx";
export var title = "section-layout-module--title--7IvAr";
export var titleText = "section-layout-module--title-text--gXf1l";